var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGetPaidOnlineBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 18a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0 1a9.5 9.5 0 110-19 9.5 9.5 0 010 19zM7 11h1a1 1 0 001 1h1a1 1 0 100-2H9a2 2 0 110-4V5h1v1a2 2 0 012 2h-1a1 1 0 00-1-1H9a1 1 0 000 2h1a2 2 0 110 4v1H9v-1a2 2 0 01-2-2z",
    fill: "#162D3D"
  })));
}

export default "data:image/svg+xml,%3csvg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.5 18C14.1944 18 18 14.1944 18 9.5C18 4.80558 14.1944 1 9.5 1C4.80558 1 1 4.80558 1 9.5C1 14.1944 4.80558 18 9.5 18ZM9.5 19C4.25329 19 0 14.7467 0 9.5C0 4.25329 4.25329 0 9.5 0C14.7467 0 19 4.25329 19 9.5C19 14.7467 14.7467 19 9.5 19ZM7 11H8C8 11.5523 8.44772 12 9 12H10C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10H9C7.89543 10 7 9.10457 7 8C7 6.89543 7.89543 6 9 6V5H10V6C11.1046 6 12 6.89543 12 8H11C11 7.44772 10.5523 7 10 7H9C8.44772 7 8 7.44772 8 8C8 8.55228 8.44772 9 9 9H10C11.1046 9 12 9.89543 12 11C12 12.1046 11.1046 13 10 13V14H9V13C7.89543 13 7 12.1046 7 11Z' fill='%23162D3D'/%3e %3c/svg%3e";
export { SvgGetPaidOnlineBusiness as ReactComponent };